import { render, staticRenderFns } from "./MostNotMets.vue?vue&type=template&id=8db4a216&"
import script from "./MostNotMets.vue?vue&type=script&lang=js&"
export * from "./MostNotMets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports